import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { autoinject } from "aurelia-framework";
import { FormAttachmentListAttributeResponse, GetFormAttachmentListAttributeRequest, GetOnboardingConfigResponse, GetOnboardingRequestResponse, GetRequiredDocumentTypesRequest, GetRequiredDocumentTypesResponse } from "../models/form.models";

@autoinject
export class RightshipOnboardingApi {
    
    public onboardingClientApi: string = `${this.configService.config.urls.rightShipPlatformApiUrl}/api/v1/OnboardingClient`
    public onboardingAdminApi: string = `${this.configService.config.urls.rightShipPlatformApiUrl}/api/v1/OnboardingAdmin`
    public rightshipOnboardingApi: string = `${this.configService.config.urls.rightShipPlatformApiUrl}/api/v1/RightShipOnboarding`

    constructor(private configService: ConfigService, private requestClientService: RequestClientService) { }

    getRequiredDocumentTypes(request: GetRequiredDocumentTypesRequest): Promise<GetRequiredDocumentTypesResponse> {

        return this.requestClientService.post(`${this.onboardingClientApi}/GetRequiredDocumentTypes`, {}, request);
    }    

    getSharedAccessSignatureToken(id: number, downloadFile: boolean): Promise<string> {
        return this.requestClientService.get(`${this.onboardingAdminApi}/GetSharedAccessSignatureToken`, { onboardingRequestDocumentId: id, downloadFile });
    }

    getOnboardingRequest(id: number): Promise<GetOnboardingRequestResponse> {
        return this.requestClientService.post(`${this.onboardingAdminApi}/GetOnboardingRequest`, {}, { onboardingRequestId: id });
    }

    getOnboardingConfig(id: number): Promise<GetOnboardingConfigResponse> {
        return this.requestClientService.get(`${this.onboardingAdminApi}/GetOnboardingConfig`, { id });
    }    
    
    public getFormAttachmentAttributes(request: GetFormAttachmentListAttributeRequest): Promise<FormAttachmentListAttributeResponse> {
        return this.requestClientService.post(`${this.rightshipOnboardingApi}/GetFormAttachmentAttributes`, {}, request); 
    }
}
